export const AnalysisRoutes = {
  AnalysisMarketAreaSearch: '/analysis/market-area/search',
  AnalysisMarketAreaSummary: '/analysis/market-area/:id/:year/summary',
  AnalysisDefaults: '/analysis/settings/defaults',
  AnalysisEquityComparables: '/analysis/settings/equity-comparables/:type',
  AnalysisSalesComparables: '/analysis/settings/sales-comparables/:type',
  AnalysisSmartLists: '/analysis/smart-lists',
  AnalysisMassUpdate: '/analysis/mass-update',
  AnalysisStrata: '/analysis/strata',
  AnalysisStrataRuns: '/analysis/stratification-runs',
  AnalysisStratifications: '/analysis/stratifications',
  SalesAnalysisTransitions: '/analysis/sales-analysis-transitions'
};
